import request from '../requesters/search'

export const getOrgAndIntroducerAndAdvisorFiltersDiscovery = async (
  input: Maybe<GetMiCaseListFilterInput>,
): Promise<OrgAndIntroducerAndAdvisorFilter> => {
  const response = await request.get<OrgAndIntroducerAndAdvisorFilter>(`/discovery/filters`, { params: input })

  return response.data || null
}
